import { Directive } from 'vue';

import { usePermissionsStore } from '@/stores';

export const can: Directive = {
  mounted(el: HTMLElement, binding) {
    const permissionsStore = usePermissionsStore();
    const permission = binding.value;

    if (!permission) return;

    if (!permissionsStore.hasPermission(permission)) {
      el.parentElement?.removeChild(el);
    }
  },
};

export const canNot: Directive = {
  mounted(el: HTMLElement, binding) {
    const permissionsStore = usePermissionsStore();
    const permission = binding.value;

    if (!permission) return;

    if (permissionsStore.hasPermission(permission)) {
      el.parentElement?.removeChild(el);
    }
  },
};
